export default {"src":"/_next/static/media/best_foods.7a9b751b.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};